export default __webpack_public_path__ + "static/media/xliteplus.68ea9d8c.webp";